module.exports = __webpack_public_path__ + "img/extra_home.d1511c00.svg";